export default ["TITLE_SEARCH", "PLANNING_CERTIFICATE", "FORM"];
